<template>
  <b-container fluid>
    <b-row class="mx-0">
      <b-col>
        <b-form>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ชื่อรายการตรวจ"
            label-for="testNameLabel"
          >
            <template v-slot:label>
              ชื่อรายการตรวจ
              <span class="text-danger">*</span>
            </template>
            <b-form-input v-model="testInput.name" />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ชื่อย่อ"
            label-for="abbreviationLabel"
          >
            <b-form-input v-model="testInput.abbreviation" />
          </b-form-group>
          <template v-if="testLevel === 'test'">
            <b-form-group
              label-cols="12"
              label-cols-sm="12"
              label-cols-md="5"
              label-cols-lg="4"
              label-cols-xl="3"
              label-align-sm="right"
              label="ประเภทผลตรวจ"
              label-for="testTypeLabel"
            >
              <template v-slot:label>
                ประเภทผลตรวจ
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="testInput.test_type_id"
                text-field="name"
                value-field="id"
                :options="testTypes"
              />
            </b-form-group>
          </template>
          <b-form-group
            v-if="testLevel === 'test'"
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="specimen Type"
            label-for="specimenTypeLabel"
          >
            <template v-slot:label>
              specimen Type
              <span class="text-danger">*</span>
            </template>
            <multiselect
              v-model="testInput.specimen_type"
              style="min-width: 200px;"
              label="name"
              track-by="name"
              :options="getSpecimenTypeAll"
              :multiple="true"
              :taggable="true"
            />
          </b-form-group>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ใช้ตัวย่อในรายงาน"
            label-for="displayAbbreviationLabel"
          >
            <template v-slot:label>
              ใช้ตัวย่อในรายงาน
              <span class="text-danger">*</span>
            </template>
            <b-form-select
              v-model="testInput.display_abbreviation"
              text-field="title"
              value-field="value"
              :options="displayAbbreviationList"
            />
          </b-form-group>
          <template v-if="testLevel === 'test'">
            <b-form-group
              label-cols="12"
              label-cols-sm="12"
              label-cols-md="5"
              label-cols-lg="4"
              label-cols-xl="3"
              label-align-sm="right"
              label="แยกจากประเภทรายการตรวจ"
              label-for="separateFromTestTypeLabel"
            >
              <template v-slot:label>
                แยกจากประเภทรายการตรวจ
                <span class="text-danger">*</span>
              </template>
              <b-form-select
                v-model="testInput.separate_from_test_type"
                text-field="title"
                value-field="value"
                :options="separateFromTestTypeList"
              />
            </b-form-group>
            <template v-if="testInput.separate_from_test_type">
              <b-form-group
                label-cols="12"
                label-cols-sm="12"
                label-cols-md="5"
                label-cols-lg="4"
                label-cols-xl="3"
                label-align-sm="right"
                label="แสดง Specimen Type"
                label-for="showSpecimentTypeLabel"
              >
                <template v-slot:label>แสดง Specimen Type</template>
                <b-form-select
                  v-model="testInput.show_specimen_type"
                  text-field="title"
                  value-field="value"
                  :options="showSpecimenTypeList"
                />
              </b-form-group>
            </template>
          </template>
          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ประเภทข้อมูล"
            label-for="inputTypeLabel"
            description="หากเป็นหัวข้อใหญ่ สามารถสร้างรายการตรวจย่อยได้หลังจากสร้างรายการตรวจนี้แล้ว"
          >
            <template v-slot:label>
              ประเภทข้อมูล
              <span class="text-danger">*</span>
            </template>
            <b-form-select
              v-model="testInput.input_type"
              text-field="title"
              value-field="value"
              :options="
                testLevel === 'subSubTest' ? inputTypeMinList : inputTypeList
              "
              value="text"
            />
          </b-form-group>
          <b-form-group
            v-if="
              testInput.input_type === 'dropdown' ||
                testInput.input_type === 'checkbox' ||
                testInput.input_type === 'radio'
            "
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ตัวเลือก"
            label-for="optionsLabel"
            style="text-align: left"
          >
            <template v-slot:label>
              ตัวเลือก
              <span class="text-danger">*</span>
            </template>
            <b-row>
              <b-col cols="auto">
                <b-button variant="primary" @click="addOptionHandler"
                  >เพิ่มตัวเลือก</b-button
                >
              </b-col>
              <b-col cols="auto" style="text-align: left">
                <small class="form-text text-muted"
                  >หากตัวเลือกเป็นประเภท checkbox หรือ radio
                  สามารถเพิ่มได้หลังจากบันทึก</small
                >
              </b-col>
            </b-row>
            <b-table
              responsive
              striped
              hover
              bordered
              :fields="optionsField"
              :items="testInput.options"
            >
              <template slot="has_sub_test" slot-scope="data">
                <div class="col-left">
                  {{ !data.item.input_type ? "ไม่มี" : data.item.input_type }}
                </div>
              </template>
              <template slot="for_specie_id" slot-scope="data">
                <div class="col-left">
                  {{
                    specieList.find((sp) => sp.id === data.item.for_specie_id)
                      ? specieList.find(
                          (sp) => sp.id === data.item.for_specie_id
                        ).species_name
                      : "ทั้งหมด"
                  }}
                </div>
              </template>
              <template slot="action" slot-scope="data">
                <b-container fluid>
                  <b-row align-h="center">
                    <b-col
                      v-if="
                        data.item.has_sub_test && data.item.id && !data.item.new
                      "
                      cols="auto"
                    >
                      <fa-icon
                        :icon="['fas', 'arrow-right']"
                        class="icon"
                        @click="openOptionModal(data.item.id)"
                      />
                    </b-col>
                    <b-col cols="auto">
                      <fa-icon
                        :icon="['fas', 'edit']"
                        class="icon warning"
                        @click="
                          editOption(
                            data.item.name,
                            data.item.has_sub_test,
                            data.item.for_specie_id
                          )
                        "
                      />
                    </b-col>
                    <b-col cols="auto">
                      <fa-icon
                        :icon="['fas', 'trash']"
                        class="icon danger"
                        @click="
                          deleteOption(
                            data.item.name,
                            data.item.has_sub_test,
                            data.item.for_specie_id
                          )
                        "
                      />
                    </b-col>
                  </b-row>
                </b-container>
              </template>
            </b-table>
          </b-form-group>
          <b-form-group
            v-if="
              testInput.input_type === 'text' ||
                testInput.input_type === 'number' ||
                testInput.input_type === 'dropdown' ||
                testInput.input_type === 'radio' ||
                testInput.input_type === 'checkbox'
            "
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="เครื่อง"
            label-for="machineLabel"
          >
            <template v-slot:label>เครื่อง</template>
            <b-form-select
              v-model="testInput.machine_id"
              text-field="name"
              value-field="id"
              :options="machineList"
            />
          </b-form-group>
          <b-form-group
            v-if="
              testInput.input_type === 'text' ||
                testInput.input_type === 'number' ||
                testInput.input_type === 'dropdown' ||
                testInput.input_type === 'radio' ||
                testInput.input_type === 'checkbox'
            "
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="Unit"
            label-for="unitLabel"
          >
            <template v-slot:label>Unit</template>
            <b-form-select
              v-model="testInput.unit_id"
              text-field="name"
              value-field="id"
              :options="unitList"
            />
          </b-form-group>
          <template v-if="testLevel === 'subTest'">
            <b-form-group
              label-cols="12"
              label-cols-sm="12"
              label-cols-md="5"
              label-cols-lg="4"
              label-cols-xl="3"
              label-align-sm="right"
              label="Remark"
              label-for="remarkLabel"
            >
              <b-form-input v-model="testInput.remark" />
            </b-form-group>
          </template>

          <template v-if="testLevel === 'test'">
            <b-form-group
              label-cols="12"
              label-cols-sm="12"
              label-cols-md="5"
              label-cols-lg="4"
              label-cols-xl="3"
              label-align-sm="right"
              label="แยกผลตรวจจาก remark"
              label-for="separateFromRemarkLabel"
            >
              <b-form-select
                v-model="testInput.separate_from_remark"
                text-field="title"
                value-field="value"
                :options="separateFromRemarkList"
              />
            </b-form-group>
            <b-form-group
              label-cols="12"
              label-cols-sm="12"
              label-cols-md="5"
              label-cols-lg="4"
              label-cols-xl="3"
              label-align-sm="right"
              label="ประเภท Lab"
              label-for="labTypeLabel"
            >
              <b-form-select
                v-model="testInput.lab_type"
                text-field="title"
                value-field="value"
                :options="labTypeList"
                value="text"
              />
            </b-form-group>
            <b-form-group
              label-cols="12"
              label-cols-sm="12"
              label-cols-md="5"
              label-cols-lg="4"
              label-cols-xl="3"
              label-align-sm="right"
              label="แสดงคำเตือน Ref Range ในรายงาน"
              label-for="displayAbbreviationLabel"
            >
              <b-form-select
                v-model="testInput.display_ref_alert"
                text-field="title"
                value-field="value"
                :options="displayRefAlertList"
              />
            </b-form-group>
          </template>

          <b-form-group
            label-cols="12"
            label-cols-sm="12"
            label-cols-md="5"
            label-cols-lg="4"
            label-cols-xl="3"
            label-align-sm="right"
            label="ใช้เฉพาะประเภทสัตว์"
            label-for="forSpecieIdLabel"
            description="หากใช้ทุกประเภทสัตว์ ไม่ต้องเลือก"
          >
            <b-form-select
              v-model="testInput.for_specie_id"
              text-field="species_name"
              value-field="id"
              :options="specieList"
            />
          </b-form-group>
          <div>
            <b-button variant="success" block @click="updateTestHandler">{{
              type === "create" ? "สร้าง" : "บันทึก"
            }}</b-button>
            <template v-if="type === 'edit'">
              <b-button variant="danger" block @click="deleteTestHandler"
                >ลบ</b-button
              >
            </template>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <b-modal
      ref="optionModal"
      :title="optionModalTitle"
      size="xl"
      :no-enforce-focus="true"
      @ok="optionSubmit"
      @cancel="resetOptionInput"
      @close="resetOptionInput"
    >
      <option-input-modal :selected-options.sync="selectedOptions" />
    </b-modal>
    <b-modal
      ref="confirmOption"
      title="ยืนยันการเพิ่ม"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="optionSubmit"
      >ต้องการเพิ่มใช่หรือไม่</b-modal
    >
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OptionInputModal from "../OptionInputModal";

export default {
  name: "TestDetail",
  components: { OptionInputModal },
  props: {
    testLevel: {
      type: String,
      default: "test",
    },
    type: {
      type: String,
      default: "create",
    },
    value: {
      type: Object,
      default: () => null,
    },
    parent: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      testInput: {
        test_type_id:
          this.testLevel === "test"
            ? this.parent
              ? this.parent.id
              : null
            : null,
        test_id:
          this.testLevel === "subTest"
            ? this.parent
              ? this.parent.id
              : null
            : null,
        sub_test_id:
          this.testLevel === "subSubTest"
            ? this.parent
              ? this.parent.id
              : null
            : null,
        parent_type: null,
        for_specie_id: null,
        is_specify_detail: null,
        price: null,
        machine_id: null,
        unit_id: null,
        abbreviation: null,
        name: null,
        has_sub_tests: false,
        input_type: null,
        show_specimen_type: false,
        separate_from_test_type: false,
        separate_from_remark: false,
        remark: null,
        display_ref_alert: true,
        display_abbreviation: false,
        has_sub_test: false,
        specimen_type: [],
        options: [],
        lab_type: null,
      },
      displayAbbreviationList: [
        {
          title: "แสดง",
          value: true,
        },
        {
          title: "ไม่แสดง",
          value: false,
        },
      ],
      separateFromTestTypeList: [
        {
          title: "แยก",
          value: true,
        },
        {
          title: "ไม่แยก",
          value: false,
        },
      ],
      separateFromRemarkList: [
        {
          title: "แยก",
          value: true,
        },
        {
          title: "ไม่แยก",
          value: false,
        },
      ],
      showSpecimenTypeList: [
        {
          title: "แสดง",
          value: true,
        },
        {
          title: "ไม่แสดง",
          value: false,
        },
      ],
      inputTypeMinList: [
        {
          title: "ตัวอักษร",
          value: "text",
        },
        {
          title: "ตัวเลข",
          value: "number",
        },
        {
          title: "ตัวเลือก Dropdown",
          value: "dropdown",
        },
        {
          title: "ตัวเลือก Radio",
          value: "radio",
        },
        {
          title: "Check Box",
          value: "checkbox",
        },
      ],
      inputTypeList: [
        {
          title: "ตัวอักษร",
          value: "text",
        },
        {
          title: "ตัวเลข",
          value: "number",
        },
        {
          title: "ตัวเลือก Dropdown",
          value: "dropdown",
        },
        {
          title: "ตัวเลือก Radio",
          value: "radio",
        },
        {
          title: "Check Box",
          value: "checkbox",
        },
        {
          title: "หัวข้อใหญ่",
          value: "heading",
        },
      ],
      optionsField: [
        {
          key: "name",
          label: "ชื่อข้อมูล",
        },
        {
          key: "has_sub_test",
          label: "มีป้อนข้อมูลเพิ่มเติม",
        },
        {
          key: "for_specie_id",
          label: "สำหรับประเภทสัตว์",
        },
        {
          key: "action",
          label: "ACTION",
        },
      ],
      displayRefAlertList: [
        {
          title: "แสดง",
          value: true,
        },
        {
          title: "ไม่แสดง",
          value: false,
        },
      ],
      hasSubTestsList: ["ไม่มี", "text", "number", "checkbox", "radio"],
      machineList: [],
      unitList: [],
      specieList: [],
      testTypes: [],
      optionModalTitle: "",
      selectedOptions: [],
      selectedOptionId: null,
      labTypeList: [
        {
          title: "In-Lab",
          value: "inlab",
        },
        {
          title: "Out-Lab",
          value: "outlab",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getSpecimenTypeAll: "Test/getSpecimenType",
      getSpecies: "Species/getAll",
    }),
  },
  watch: {
    value(value) {
      let input = {
        test_type_id:
          this.testLevel === "test"
            ? this.parent
              ? this.parent.id
              : null
            : null,
        test_id:
          this.testLevel === "subTest"
            ? this.parent
              ? this.parent.id
              : null
            : null,
        sub_test_id:
          this.testLevel === "subSubTest"
            ? this.parent
              ? this.parent.id
              : null
            : null,
        parent_type: null,
        for_specie_id: null,
        is_specify_detail: null,
        price: null,
        machine_id: null,
        unit_id: null,
        abbreviation: null,
        name: null,
        has_sub_tests: false,
        input_type: null,
        separate_from_test_type: false,
        separate_from_remark: false,
        remark: null,
        display_ref_alert: true,
        display_abbreviation: false,
        show_specimen_type: false,
        has_sub_test: false,
        specimen_type: [],
        options: [],
        lab_type: null,
      };
      if (value) {
        input = { ...value, options: value.test_option };
      }
      this.assignTestInput(input);
      this.assignParentType();
    },
  },
  async mounted() {
    this.$store.state.isLoading = true;
    if (this.value) {
      this.assignTestInput({ ...this.value, options: this.value.test_option });
    }
    this.assignParentType();

    this.machineList = await this.getMachines();
    this.unitList = await this.getUnits();
    this.specieList = this.getSpecies;
    this.testTypes = await this.getTestTypes();
    this.$store.state.isLoading = false;
  },
  methods: {
    ...mapActions({
      getMachines: "Settings/getMachine",
      getUnits: "Settings/getUnits",
      getTestTypes: "Settings/getTestTypeList",
    }),
    assignParentType() {
      let parentType = null;
      if (this.testLevel === "subTest") {
        parentType = "test";
      } else if (this.testLevel === "subSubTest") {
        parentType = "subTest";
      }
      this.testInput.parent_type = parentType;
    },
    assignTestInput(value) {
      this.testInput = { ...value };
    },
    async updateTestHandler() {
      // const type = this.type === 'create' ? 'สร้าง' : 'บันทึก'
      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        if (this.testInput.input_type === "heading") {
          if (this.testLevel === "test") {
            this.testInput.has_sub_tests = true;
          } else if (this.testLevel === "subTest") {
            this.testInput.has_sub_test = true;
          }
        } else {
          if (this.testLevel === "test") {
            this.testInput.has_sub_tests = false;
          } else if (this.testLevel === "subTest") {
            this.testInput.has_sub_test = false;
          }
        }
        this.$emit("submit", { ...this.testInput, password });
      } else {
        return;
      }
    },
    async deleteTestHandler() {
      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        this.$emit("delete", { id: this.testInput.id, password });
      } else {
        return;
      }
    },
    async addOptionHandler() {
      const result = await this.$swal
        .mixin({
          confirmButtonText: "Next &rarr;",
          showCancelButton: true,
          progressSteps: ["1", "2", "3"],
        })
        .queue([
          {
            input: "text",
            title: "ชื่อตัวเลือก",
          },
          {
            title: "มีป้อนข้อมูลเพิ่มเติม",
            text: "มีป้อนข้อมูลเพิ่มเติมในตัวเลือก",
            input: "select",
            inputOptions: this.hasSubTestsList,
          },
          {
            title: "ใช้เฉพาะประเภทสัตว์",
            text: "หากใช้ทุกประเภทสัตว์ ไม่ต้องเลือก",
            input: "select",
            inputOptions: this.specieList.map((specie) => specie.species_name),
          },
        ]);

      if (result.value) {
        const name = result.value[0];
        const has_sub_test =
          "0" !== result.value[1] &&
          "1" !== result.value[1] &&
          "2" !== result.value[1];
        let input_type;
        if (result.value[1] !== "0") {
          input_type = this.hasSubTestsList[result.value[1]];
        }
        const for_specie_id =
          "0" === result.value[2] ? null : +result.value[2] + 1;
        let newOption = { name, has_sub_test, for_specie_id };
        if (input_type) {
          newOption = Object.assign(newOption, { input_type, new: true });
          if (input_type === "text" || input_type === "number") {
            newOption = Object.assign(newOption, { has_text_field: true });
          }
        }
        if (!this.testInput.options) {
          this.testInput.options = [];
        }
        this.testInput.options = this.$rfdc([
          ...this.testInput.options,
          newOption,
        ]);
      }
    },
    deleteOption(name, has_sub_test, for_specie_id) {
      let options = this.testInput.options.filter(
        (option) =>
          !(
            option.name === name &&
            option.has_sub_test === has_sub_test &&
            option.for_specie_id === for_specie_id
          )
      );
      this.$swal
        .fire({
          title: "ยืนยันการลบ?",
          text: `คุณต้องการที่จะลบตัวเลือก ${
            this.testInput.options.find((option) => option.name === name).name
          } ใช่หรือไม่`,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ใช่ ยืนยันการลบ!",
          cancelButtonAriaLabel: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            this.testInput.options = options;
          }
        });
    },
    async editOption(name, has_sub_test, for_specie_id) {
      let options = this.$rfdc(this.testInput.options);
      let optionIndex = options.findIndex(
        (option) =>
          option.name === name &&
          option.has_sub_test === has_sub_test &&
          option.for_specie_id === for_specie_id
      );

      const result = await this.$swal
        .mixin({
          confirmButtonText: "Next &rarr;",
          showCancelButton: true,
          progressSteps: ["1", "2", "3"],
        })
        .queue([
          {
            input: "text",
            title: "ชื่อตัวเลือก",
          },
          {
            title: "มีป้อนข้อมูลเพิ่มเติม",
            text: "มีป้อนข้อมูลเพิ่มเติมในตัวเลือก",
            input: "select",
            inputOptions: this.hasSubTestsList,
          },
          {
            title: "ใช้เฉพาะประเภทสัตว์",
            text: "หากใช้ทุกประเภทสัตว์ ไม่ต้องเลือก",
            input: "select",
            inputOptions: this.specieList.map((specie) => specie.species_name),
          },
        ]);

      if (result.value) {
        const name = result.value[0];
        const has_sub_test =
          "0" !== result.value[1] &&
          "1" !== result.value[1] &&
          "2" !== result.value[1];
        let input_type;
        if (result.value[1] !== "0") {
          input_type = this.hasSubTestsList[result.value[1]];
        }
        const for_specie_id =
          "0" === result.value[2] ? null : +result.value[2] + 1;

        if (input_type) {
          options[optionIndex].input_type = input_type;
          if (input_type === "text" || input_type === "number") {
            options[optionIndex].has_text_field = true;
          }
        } else {
          if (options[optionIndex].input_type) {
            delete options[optionIndex].input_type;
          }
          options[optionIndex].has_text_field = false;
        }

        options[optionIndex].name = name;
        options[optionIndex].has_sub_test = has_sub_test;
        options[optionIndex].for_specie_id = for_specie_id;
        options[optionIndex].new = true;

        this.$nextTick(() => {
          this.testInput.options = options;
        });
      }
    },
    openOptionModal(optionId) {
      this.$refs["optionModal"].show();
      let option = this.testInput.options.find((opt) => opt.id === optionId);
      this.optionModalTitle = `ตัวเลือกของ ${option.name}`;
      if (option.for_specie_id) {
        this.optionModalTitle += ` สำหรับ ${
          this.specieList.find((specie) => specie.id === option.for_specie_id)
            .species_name
        }`;
      } else {
        this.optionModalTitle += ` สำหรับทั้งหมด`;
      }
      this.selectedOptions = option.options;
      this.selectedOptionId = option.id;
    },
    optionSubmit() {
      let options = this.$rfdc(this.testInput.options);
      let optionIndex = options.findIndex(
        (option) => option.id === this.selectedOptionId
      );
      options[optionIndex].options = this.selectedOptions;
      this.testInput.options = options;
      this.resetOptionInput();
    },
    resetOptionInput() {
      this.selectedOptions = [];
      this.selectedOptionId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.swall-overlay {
  z-index: 100005;
}
.swal-modal {
  z-index: 99999;
}
.icon {
  cursor: pointer;
  &.warning {
    color: #ffc107;
  }
  &.danger {
    color: #dc3545;
  }
  &.disable {
    opacity: 0.4;
    cursor: default;
  }
}
</style>
